<template>
  <ValidationProvider
    v-bind="$props"
    :name="computedName"
    slim
  >
    <template #default="slotProps">
      <component
        :is="component"
        ref="innerComponent"
        v-bind="{ ...$attrs, ...mapProps(slotProps) }"
        :pending="$pendingApiRequest()"
        v-on="$listeners"
      >
        <slot />
        <template 
          v-for="(index, name) in $scopedSlots" 
          #[name]="data"
        >
          <slot 
            :name="name" 
            v-bind="data" 
          />
        </template>
      </component>
    </template>
  </ValidationProvider>
</template>

<script>
import { ValidationProvider } from 'vee-validate';
import { registerEventListener } from '@/event-bus/event-bus';

const usedProps = Object.fromEntries(
  Object.entries(ValidationProvider.options.props).filter(
    arr => arr[0] != 'disabled'
  )
);

// ValidationWrapper will not work if the component defined in the data properties has a custom model
export default {
  name: 'ValidationWrapper',
  inject: {
    formFields: {},
    $pendingApiRequest: { default: () => () => false }
  },
  props: usedProps,
  components: { ValidationProvider },
  data() {
    return {
      component: undefined,
      mapProps: () => ({}),
      isFocusable: true,
    };
  },
  methods: {
    registerField() {
      const vid = this.$props.vid;
      if (vid) this.formFields[vid] = { name: this.$props.name || this.$attrs.label, isFocusable: this.isFocusable };
    }
  },
  computed: {
    computedName() {
      return this.$props.name || this.$attrs.label;
    }
  },
  mounted() {
    this.registerField();
  },
  mixins: [
    registerEventListener('focus', 'focusInput',
      function (value) { if (this.$props.vid === value) this.$refs.innerComponent.focus(); })
  ]
}
</script>